import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MobileApp } from './mobile/MobileApp';
import { WebApp } from './web/WebApp';
export function App() {
  const isMobile = useMediaQuery({
    maxWidth: 768
  });
  return <div className="w-full min-h-screen bg-background" data-id="element-0">
      {isMobile ? <MobileApp data-id="element-1" /> : <WebApp data-id="element-2" />}
    </div>;
}